module.exports = __webpack_public_path__ + "static/media/M82ws.896662bf.pdf";